import { FormStore } from '../../Participants/AddParticipant/Stores/FormStore';

const importFormStore = new FormStore();

export { importFormStore };
export type { FormStore };
